import { useState } from 'react';

import { PlusIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';

import { RoleNameForm } from '@/components/pages/ManageAccess/RoleNameForm';
import { Button } from '@/components/ui/button';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { selectAccountSlug } from '@/redux/session/selectors';

import { newRolePath, NewRoleState } from './newRole';

type Props = { disabled?: boolean };

export const CreateRolePopover = ({ disabled }: Props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const slug = useSelector(selectAccountSlug);
  const [isOpen, setIsOpen] = useState(false);

  const handleSubmit = (roleName: string) => {
    setIsOpen(false);
    navigate(newRolePath(slug), { state: { roleName } satisfies NewRoleState });
  };

  return (
    <Popover open={isOpen} onOpenChange={setIsOpen}>
      <PopoverTrigger asChild>
        <Button size="sm" disabled={disabled}>
          <PlusIcon size={16} />
          {t('common.create')}
        </Button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-80 p-0">
        <RoleNameForm
          title={t('roles.create_custom_role')}
          submitLabel={t('common.continue')}
          onSubmit={handleSubmit}
          onCancel={() => setIsOpen(false)}
        />
      </PopoverContent>
    </Popover>
  );
};
